var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40919 3.59961C1.87313 3.59961 0.600098 4.8268 0.600098 6.37461V9.59957H23.4001V6.37461C23.4001 4.8268 22.1271 3.59961 20.591 3.59961H3.40919Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 11.6996H0.600098V17.6246C0.600098 19.1724 1.87313 20.3996 3.40919 20.3996H20.591C22.1271 20.3996 23.4001 19.1724 23.4001 17.6246V11.6996Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionActive);
export default __webpack_public_path__ + "static/media/subscription-active.745bfa6ee35a65138422cd52be03fc77.svg";
export { ForwardRef as ReactComponent };